import { BitfRestPathBuilder } from '../rest-parser/bitf-rest-path.builder';

export abstract class BitfNetPathBuilder extends BitfRestPathBuilder {}
